import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Wrapper } from '../../components/wrapper.component';
import { sleepForMS } from '../../helpers/helpers';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { CommonModule } from '@angular/common';

const ERROR_DISPLAY_MS = 3000
@Component({
    selector: 'new-app-dialog',
    template: `
<dialog-wrapper
  [backgroundColor]="'var(--primary)'"
  [disabled]="!title || creating"
  [successLabel]=""
  [dialogTitle]="'Create an Event App'"
  [smallTitle]="true"
  [cancelLeft]="true"
  [showClose]="false"
  [maxHeight]="'unset'"
  [deleteLeft]="false"
  [successLabel]="'CREATE'"
  [data]="null"
  (cancel)="dialogRef.close()"
  (submit)="create()"
>
  <div class="instructions">Give your Event app a unique name. This will be the name your audience will use to search for the event in the app.</div>
  <mutating-input [disabled]="creating" [object]="this" [prop]="'title'" [error]="error" [placeholder]="'Event app name'"></mutating-input>
  <mutating-input [disabled]="creating" [object]="this" [prop]="'description'" [placeholder]="'Event app description'"></mutating-input>
</dialog-wrapper>
  `,
    styles: [`
  .instructions { margin-bottom: 20px; }  
`],
    standalone: true,
    imports: [MutatingInputComponent, DialogWrapperComponent, CommonModule],
})
export class NewAppDialogComponent extends Wrapper<NewAppDialogComponent> {
  title = ''
  description = ''
  creating = false
  error = ''
  

  constructor(public dialogRef: MatDialogRef<NewAppDialogComponent>) { 
    super()
  }

  async create() {
    this.creating = true
    const created: 'success' | 'not-unique' | 'no-permission' | 'error' | boolean = await this.appService.createAppInfo(this.title, this.description || '')
    switch (created) {
      case 'not-unique':
        this.setError('This name is not unique. Try again');
        break;
      case 'no-permission':
        this.setError('You do not have permission to create an app for this event.');
        break;
      case 'error':
        this.setError('An error occurred while creating the app. Please try again.');
        break;
      case 'success':
        this.dialogRef.close(true);
        break;
      default:
        this.setError('An unexpected error occurred. Please try again.');
    }
    this.creating = false
  }

  async setError(error) {
    this.error = error
    await sleepForMS(ERROR_DISPLAY_MS)
    this.error = ''
  }

}